import * as React from 'react';
import { Button, Modal, Panel } from '@ixicare/ui';
import { useNavigate } from 'react-router-dom';
import siteWrapper, { SiteWrapperProps } from '../utils/siteWrapper';
import { useBreadcrumbs } from '~components/DashboardWrapper/Breadcrumbs';
import GeoPlaneCreate, { CreatedPlane } from '~components/Map/GeoPlaneCreate';
import SitePlaneForm from '../containers/SitePlaneForm';
import { t } from '~i18n';
import styles from './Map.module.css';

type SitePlaneCreatePageProps = SiteWrapperProps;

const SitePlaneCreatePage: React.FC<SitePlaneCreatePageProps> = ({ site }) => {
  const navigate = useNavigate();
  const [showLegacyForm, setShowLegacyForm] = React.useState(false);

  useBreadcrumbs([{ label: t('site.floors.create') }]);

  const handlePlaneCreated = React.useCallback(
    async (plane: CreatedPlane) => {
      // The map created the plane; refresh the site so its planes list includes the new plane
      // before navigating to the viewer (which looks it up by id).
      await site.refresh();
      navigate(`/sites/${site.uuid}/${plane.id}`);
    },
    [site, navigate]
  );

  return (
    <Panel>
      <Panel.Title>
        {site.name} {t('site.planes')}
      </Panel.Title>
      <Panel.Right>
        <Button buttonType="inverse" onClick={() => setShowLegacyForm(true)}>
          {t('site.floors.legacyCreate')}
        </Button>
      </Panel.Right>

      <div className={styles.MapWrapper}>
        <GeoPlaneCreate siteId={site.id} safeAreaTop={10} showZoom onPlaneCreated={handlePlaneCreated} />
      </div>

      {showLegacyForm && (
        <Modal onClose={() => setShowLegacyForm(false)}>
          <SitePlaneForm site={site} />
        </Modal>
      )}
    </Panel>
  );
};

export default siteWrapper(SitePlaneCreatePage);
